import constants from '@/app-configs/constants'

export default [
  {
    path: '/bcapi-settings',
    name: 'bcapi-settings',
    component: () => import('@/views/settings/BCAPISettings.vue'),
    meta: {
      pageTitle: 'DEBTIA_BC_API_SETTINGS',
      breadcrumb: [
        {
          text: 'DEBTIA_BC_API_SETTINGS',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
  },
]
